/**
 * File: format-excerpt.js
 *
 * Format the job listing excerpt.
 */

// Make sure everything is loaded first.
if (
  ("complete" === document.readyState || "loading" !== document.readyState) &&
  !document.documentElement.doScroll
) {
  format_excerpt();
} else {
  document.addEventListener("DOMContentLoaded", format_excerpt);
}

/**
 * Format the job listing excerpt.
 *
 * @author Julian M.
 */
function format_excerpt() {
  const excerpts = document.querySelectorAll(".job_listing .excerpt");

  const toRemove = "General Job Responsibilities";

  if (excerpts.length < 1) return;

  excerpts.forEach((excerpt) => {
    const excerptText = excerpt.innerText;

    if (excerptText.startsWith(toRemove)) {
      const newText = excerptText.replace(toRemove, "");
      excerpt.innerText = newText;
    }
  });
}
